import React, { Component } from 'react';
import { withTranslate } from 'react-redux-multilingual';

import HeaderLogin from './common/headers/header-login';
import HeaderWelcome from './common/headers/header-welcome';
import PageLoader from './layouts/loader/main';

class App extends Component {
  headerWelcomeRoutes = [
    '/cart',
    '/referred-orders',
    '/referred-checkout',
    '/user-checkout',
    '/register-referred',
    '/register-address',
    '/profile',
    '/referreds',
    '/thanks',
    '/debt',
    '/closed'
  ];

  getHeaderComponent() {
    const { pathname } = this.props.location;

    if (this.headerWelcomeRoutes.includes(pathname)) {
      return (
        <HeaderWelcome
          logoName="ver_logo.png"
          showNav={true}
          changeBackgroundColor={false}
          homeView={true}
          changeClass="header_cart"
        />
      );
    }

    if (pathname.startsWith('/products/')) {
      return (
        <HeaderWelcome
          logoName="ver_logo2.png"
          showNav={true}
          changeBackgroundColor={true}
          changeClass="header_products"
        />
      );
    }

    if (pathname.startsWith('/categProducts/')) {
      return (
        <HeaderWelcome
          logoName="ver_logo.png"
          showNav={true}
          transparentBackground={true}
          changeBackgroundColor={false}
          homeView={true}
          changeClass="transparent_header"
        />
      );
    }

    if (pathname.startsWith('/more-products')) {
      return (
        <HeaderWelcome
          logoName="ver_logo.png"
          showNav={true}
          transparentBackground={true}
          changeBackgroundColor={false}
          homeView={true}
          changeClass="transparent_header"
        />
      );
    }

    if (pathname.startsWith('/accesories/')) {
      return (
        <HeaderWelcome
          logoName="ver_logo.png"
          showNav={true}
          transparentBackground={true}
          homeView={true}
          changeClass="transparent_header"
        />
      );
    }

    const publicWelcomeRoutes = ['/login', '/', '/welcome', '/unauthorized'];
    
    const isPublicRoute =
      publicWelcomeRoutes.includes(pathname) ||
      pathname.startsWith('/paydebt');

    if (!isPublicRoute) {
      return <HeaderWelcome logoName="ver_logo.png" showNav={true} />;
    }



    return <HeaderLogin />;
  }

  render() {
    return (
      <div>
        <PageLoader />
        {this.getHeaderComponent()}
        {this.props.children}
      </div>
    );
  }
}

export default withTranslate(App);
